// @ts-check

class Trigger {
  /** @type {EventTarget} */
  _eventTarget

  /** @type {Object<String, () => any>} */
  _handlers

  constructor() {
    this._eventTarget = new EventTarget()
    this._handlers = {}
  }

  /**
   * Subscribe to trigger
   * @param {() => any} cb callback to be called when trigger fires
   */
  subscribe(cb) {
    this._handlers[cb.toString()] = cb
    this._eventTarget.addEventListener('trigger', cb)
  }

  /**
   * Unsubscribe to trigger
   * @param {() => any} cb callback to unsubscribe
   */
  unsubscribe(cb) {
    const callback = this._handlers[cb.toString()]
    delete this._handlers[cb.toString()]
    this._eventTarget.removeEventListener('trigger', callback)
  }

  /**
   * Destroy Trigger instance
   */
  destroy() {
    Object.keys(this._handlers).forEach((cb) =>
      this.unsubscribe(this._handlers[cb])
    )
  }

  /**
   * Private function that runs all subscribed callback. This should be called
   * from this class childs.
   */
  _dispatch() {
    this._eventTarget.dispatchEvent(new Event('trigger'))
  }
}

export { Trigger }
